import { ADD, SAVE, MOVE } from "./actions";

const initialState = {
    cart_items: [],
    is_saved: true
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD: {
            return {
                ...state,
                cart_items: action.data.cart_items,
                table_id: action.data.table_id
            };
        }
        case SAVE: {
            return {
                ...state,
                is_saved: action.data
            };
        }

        case MOVE: {
            return {
                ...state,
                table_id: action.data
            };
        }

        default: {
            return state;
        }
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/services/store/reducers/cart/index.js